"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultScatterChartOptions = exports.tickLength = void 0;
var tickLength = 6;
exports.tickLength = tickLength;
var defaultScatterChartOptions = {
  chart: {
    type: 'scatter',
    styledMode: true
  },
  title: {
    text: undefined
  },
  subtitle: {
    text: undefined
  },
  legend: {
    enabled: false
  },
  tooltip: {
    useHTML: true
  },
  credits: {
    enabled: false
  },
  xAxis: {
    gridLineWidth: 1,
    crosshair: {
      width: 1.5
    },
    title: {
      enabled: false
    },
    tickLength: 0,
    lineWidth: 1,
    labels: {
      enabled: false
    }
  },
  yAxis: {
    gridLineWidth: 1,
    crosshair: {
      width: 1.5
    },
    title: {
      enabled: false
    },
    tickLength: 0,
    lineWidth: 1,
    labels: {
      enabled: false
    }
  },
  plotOptions: {
    scatter: {
      cursor: 'pointer',
      marker: {
        symbol: 'circle',
        radius: 9,
        states: {
          hover: {
            radius: 11
          }
        }
      }
    }
  },
  series: []
};
exports.defaultScatterChartOptions = defaultScatterChartOptions;